import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    bar: {
      transitionDuration: '0ms',
      background: theme.colors.neutral[3],
    },
    root: {
      maxWidth: `calc(100% - 16px)`,
      marginLeft: 0,
      marginRight: 0,
      height: rem(4),
      background: 'transparent',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        content: '""',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: '#fff',
        opacity: 0.25,
      },
    },
  }
})
